import './custom'

import cre8select from './_8select'

const _8select = cre8select(window._8select || {})

export default _8select
